import React from 'react';
import PropTypes from 'prop-types';
import StripeSEPAProp from '../../../../payments/propTypes/StripeSEPAProp';

function SEPADebitItem({
  idx,
  sepaDebit,
  isSelected,
  onSelectSEPADebit,
  onRemoveSEPADebit,
}) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for
    <label key={sepaDebit.id} className="card-container">
      <input
        type="radio"
        name="credit-card"
        checked={isSelected}
        onChange={() => onSelectSEPADebit(sepaDebit.id)}
      />
      <span className="custom-radio" />

      <div className="card-details">
        <div className="card-number">
          **** **** **** ********{sepaDebit.last4}
          <img alt={`${sepaDebit.bank_code} logo`} src={sepaDebit.logo} />
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/control-has-associated-label */}
      <button
        type="button"
        tabIndex={idx}
        onClick={() => {
          onRemoveSEPADebit(sepaDebit.id);
        }}
        className="btn btn-metal m-btn m-btn--icon
                              m-btn--icon-only m-btn--custom m-btn--pill"
      >
        <i className="fa fa-trash-alt" />
      </button>
    </label>
  );
}

SEPADebitItem.propTypes = {
  idx: PropTypes.number.isRequired,
  sepaDebit: PropTypes.shape(StripeSEPAProp.propType).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelectSEPADebit: PropTypes.func.isRequired,
  onRemoveSEPADebit: PropTypes.func.isRequired,
};

SEPADebitItem.defaultProps = {};

export default SEPADebitItem;
